import { render } from "./Position.vue?vue&type=template&id=efe26e7e&ts=true"
import script from "./Position.vue?vue&type=script&lang=ts"
export * from "./Position.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__